import type { BaseDataPoint } from "./charts";

/**
 * Insert a single `null` break-marker between consecutive points whose time
 * spacing exceeds `maxGapMs`, so a renderer using `defined={(d) => d != null}`
 * breaks the line/area across missing data instead of connecting across it.
 *
 * Both real points are kept; only the connecting segment is broken. A spacing
 * exactly equal to `maxGapMs` is treated as continuous. No-op for `maxGapMs <= 0`
 * or fewer than 2 points.
 */
export function splitOnGaps(data: BaseDataPoint[], maxGapMs: number): (BaseDataPoint | null)[] {
  if (maxGapMs <= 0 || data.length < 2) return data;

  const result: (BaseDataPoint | null)[] = [data[0]];
  for (let i = 1; i < data.length; i++) {
    if (data[i].xValue.getTime() - data[i - 1].xValue.getTime() > maxGapMs) {
      result.push(null);
    }
    result.push(data[i]);
  }
  return result;
}
